import { Container } from 'components/container'
import styled from 'styled-components/macro'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const StyledFooter = styled.footer`
  position: relative;
  padding-block: 6rem;
  font-size: 1.8rem;
  background-color: white;

  ${Container} {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 1em;
    z-index: 2;

    p {
      margin: 0;
    }

    ${mq.medium} {
      flex-direction: row;
      flex-wrap: wrap;
      align-items: end;
      justify-content: space-between;
      text-align: initial;
    }
  }
`

export const Heading = styled.h4`
  font-weight: bold;
  font-size: 2.1rem;
  margin: 0;

  &:not(:first-child) {
    margin-top: 6rem;
  }
`

export const SocialLinks = styled.ul`
  margin: 0.5rem 0 5rem;
  padding: 0;
  list-style: none;

  li {
    display: inline;
    padding: 0;
    margin: 0;
  }

  a {
    display: inline-block;
    font-size: 4rem;
    width: 1em;
    height: 1em;
    margin-right: 0.2em;
    color: inherit;
    transition: all 0.3s;
    overflow: hidden;
    background-color: var(--text-color);
    border-radius: 50%;

    ${mq.smallOnly} {
      width: 0.8em;
      height: 0.8em;
    }

    svg {
      display: block;
      color: white;

      ${mq.smallOnly} {
        width: 0.8em;
      }
    }

    &:hover,
    &:focus {
      color: black;
      background-color: ${theme.colors.accent.rfe};
    }
  }
`

export const Copyright = styled.p`
  font-size: 1.6rem;
`
